import { render, staticRenderFns } from "./SalesCommissions.vue?vue&type=template&id=fb12a8ce"
import script from "./SalesCommissions.vue?vue&type=script&lang=js"
export * from "./SalesCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports